import React from 'react';
export function CostComparison() {
  const data = [{
    sin: 'El sueldo se va sin saber cómo',
    costo: 'Estrés, angustia y sensación de fracaso constante'
  }, {
    sin: 'Sin sistema de presupuesto',
    costo: 'La inflación te come el esfuerzo mes a mes'
  }, {
    sin: 'Sin estrategia de ahorro',
    costo: 'Nunca construís un colchón real'
  }, {
    sin: 'Sin conocimiento de inversión',
    costo: 'Otros multiplican su plata mientras vos la perdés'
  }, {
    sin: 'Sin control de deudas',
    costo: 'Pagás intereses toda la vida sin salir nunca'
  }, {
    sin: 'Sentirte mal con tu situación económica',
    costo: 'El costo más alto de todos'
  }];
  return <section className="bg-cream py-16 px-4 border-t border-border" data-id="element-63">
      <div className="max-w-4xl mx-auto" data-id="element-64">
        <h2 className="text-3xl md:text-5xl font-bold text-center text-ink mb-10 font-serif" data-id="element-65">
          ⚖️ ¿CUÁNTO CUESTA NO TENERLO?
        </h2>

        <div className="bg-white rounded-3xl overflow-hidden border border-border shadow-md mb-10" data-id="element-66">
          <div className="grid grid-cols-2 bg-surface border-b border-border" data-id="element-67">
            <div className="p-6 text-center font-bold text-ink text-base md:text-lg" data-id="element-68">
              Sin Dominio Financiero
            </div>
            <div className="p-6 text-center font-bold text-base md:text-lg text-urgency" data-id="element-69">
              Costo real
            </div>
          </div>
          <div className="divide-y divide-border" data-id="element-70">
            {data.map((row, i) => <div key={i} className="grid grid-cols-2 hover:bg-surface transition-colors" data-id="element-71">
                <div className="p-6 text-ink flex items-center justify-center text-center text-sm md:text-base font-medium" data-id="element-72">
                  {row.sin}
                </div>
                <div className="p-6 font-bold flex items-center justify-center text-center bg-urgency/5 text-urgency text-sm md:text-base" data-id="element-73">
                  {row.costo}
                </div>
              </div>)}
          </div>
        </div>

        <div className="text-center" data-id="element-74">
          <p className="text-2xl md:text-4xl font-bold text-ink italic font-serif" data-id="element-75">
            El próximo mes puede ser diferente.
          </p>
          <p className="text-xl md:text-3xl text-primary mt-4 font-bold" data-id="element-76">
            "El próximo cobro puede ser diferente." 💰
          </p>
        </div>
      </div>
    </section>;
}